<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col
              md="4"
              v-for="(item, index) in getHeaders(rule)"
              :key="index"
            >
              <v-text-field
                v-model="rule[item.value]"
                :label="item.text"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">OK</v-btn>
          <v-btn color="primary" @click="init">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AddRule",

  data() {
    return {
      rule: {},
      addPlan: {},
      dialog: false
    };
  },

  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    populate(val) {
      this.init();
      Object.assign(this.rule, {
        handsetOverride: false,
        dealerType: 1,
        ratePlanId: parseInt(val.servicePlanNo, 10),
        amount: 0.0,
        ratePlanDescription: val.servicePlanDescription,
        categoryId: 3,
        usageType: val.usageType
      });
      this.dialog = true;
    },
    init() {
      Object.assign(this.rule, {
        amount: 0.0,
        handsetOverride: false,
        dealerType: 0,
        ratePlanId: 0,
        ratePlanDescription: "",
        categoryId: 3,
        usageType: ""
      });
      this.dialog = false;
      this.$emit('init');
    },
    save() {
      let vm = this;
      if (this.dialog) {
        vm.rule.amount = parseFloat(vm.rule.amount);
        let query = {
          message: "New Rule added",
          url: `Commissions/AddCommsRule/`,
          method: "post",
          body: vm.rule
        };
        this.CommissionsRequest(query)
          .then(() => {
            vm.init();
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
